import React from 'react';
import { ANNOTATION_TYPE } from '../../../image/labelling/constants';
import { useKeyboardShortcuts } from '../../hotkey/useKeyboardShortcuts';
import type { AnnotationLabelT, GenericAnnotationT, ShowNotificationT } from '../../types/types';
import type { SelectLabelPayloadT } from '../analytics/types';
import useAnalyticsForSidePanel from '../analytics/useAnalyticsForSidePanel';
import AnnotationLabel from '../annotation-label';
import { getLabelsOfAnnotationType } from '../utils/utils';
import { getInitialLabels, getInstanceTitle, getRandomRGBColor } from './utils';
type PropsT = {
  annotationLabels: AnnotationLabelT[];
  selectedAnnotationLabel: AnnotationLabelT | undefined | null;
  onSetAnnotationLabel: (a: AnnotationLabelT) => void;
  annotationList: GenericAnnotationT[];
  showNotification?: ShowNotificationT;
};
const SegmentationLabels = ({
  annotationLabels,
  selectedAnnotationLabel,
  onSetAnnotationLabel,
  annotationList,
  showNotification
}: PropsT) => {
  const {
    sendEventForLabelSelection
  } = useAnalyticsForSidePanel();
  const [labels, setLabels] = React.useState<({
    instanceLabels: {
      title: string;
      color: string;
    }[];
  } & AnnotationLabelT)[]>(() => {
    const segmentationLabels = getLabelsOfAnnotationType(annotationList, ANNOTATION_TYPE.SEGMENTATION);
    return getInitialLabels(annotationLabels, segmentationLabels);
  });
  const onEnterPress = () => {
    if (selectedAnnotationLabel) {
      const index = labels.findIndex(label => label.title === selectedAnnotationLabel.title.split('_')[0]);
      if (index !== -1) {
        // eslint-disable-next-line react-hooks/immutability
        onAddAnnotationLabel(labels[index], index);
      }
    }
  };
  useKeyboardShortcuts(['Enter'], onEnterPress, 'keydown');
  const selectAnnotationLabel = label => {
    const {
      instanceLabels,
      ...annotationLabel
    } = label;
    onSetAnnotationLabel(annotationLabel);
    const eventPayload: SelectLabelPayloadT = {
      label: annotationLabel.title
    };
    sendEventForLabelSelection(eventPayload);
  };
  const onAddAnnotationLabel = (annotationLabel, index) => {
    const newLabels = [...labels];
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    const title = getInstanceTitle(annotationLabel.title, newLabels[index].instanceLabels);
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    newLabels[index].instanceLabels.push({
      title: title,
      color: getRandomRGBColor()
    });
    setLabels(newLabels);

    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    const currentLabel = labels[index].instanceLabels[labels[index].instanceLabels.length - 1];
    const label = {
      ...annotationLabel,
      // @ts-expect-error todo(ts-migration) TS18048 'currentLabel' is possibly 'undefined'.
      title: currentLabel.title,
      style: {
        ...annotationLabel.style,
        // @ts-expect-error todo(ts-migration) TS18048 'currentLabel' is possibly 'undefined'.
        fillColor: currentLabel.color,
        // @ts-expect-error todo(ts-migration) TS18048 'currentLabel' is possibly 'undefined'.
        strokeColor: currentLabel.color
      },
      instanceLabelTitle: annotationLabel.title
    };
    selectAnnotationLabel(label);
  };
  return <>
      {labels.map((annotationLabel, index) => {
      const instanceLabels = annotationLabel.instanceLabels.map(instanceLabel => {
        const label = {
          ...annotationLabel,
          title: instanceLabel.title,
          style: {
            ...annotationLabel.style,
            fillColor: instanceLabel.color,
            strokeColor: instanceLabel.color
          }
        };
        return <AnnotationLabel key={instanceLabel.title} annotationLabel={label} isSelected={instanceLabel.title === selectedAnnotationLabel?.title} onAnnotationClick={() => {
          selectAnnotationLabel({
            ...label,
            instanceLabelTitle: annotationLabel.title
          });
        }} isChild showNotification={showNotification} />;
      });
      return <div key={annotationLabel.title}>
            <AnnotationLabel key={annotationLabel.title} annotationLabel={annotationLabel} isSelected={annotationLabel.title === selectedAnnotationLabel?.title} onAnnotationClick={() => {
          selectAnnotationLabel(annotationLabel);
        }} onAddAnnotationLabel={() => onAddAnnotationLabel(annotationLabel, index)} showNotification={showNotification} />
            {instanceLabels}
          </div>;
    })}
    </>;
};
export default SegmentationLabels;